<template>
  <div class="actions-toolbar">
    <v-toolbar
      v-if="$vuetify.breakpoint.smAndUp"
      class="mt-3"
      floating
      dense
    >
      <v-autocomplete
        :items="vehicles"
        v-model="selectedVehicle"
        item-text="plate"
        return-object
        prepend-icon="directions_car"
        label="Vehículos"
        single-line
        :loading="loading"
      ></v-autocomplete>
      <v-menu v-if="selectedVehicle" offset-y bottom left>
        <v-btn icon slot="activator" @click="unreadEvents = 0">
          <v-badge v-model="unreadEventsBadge.visible" right>
            <span color="primary" slot="badge">{{ unreadEventsBadge.value }}</span>
            <v-icon>track_changes</v-icon>
          </v-badge>
        </v-btn>
        <v-toolbar>
          <v-toolbar-title>Eventos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon>settings</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="events-menu-body">
          <v-list two-line>
            <v-list-tile
              avatar
              v-for="event in events"
              :key="event._id"
              @click="$emit('open-event-dialog', event._id)"
            >
            <v-list-tile-avatar>
              <v-icon v-if="event.highPriority" class="primary white--text">priority_high</v-icon>
              <v-icon v-else class="primary white--text">notifications</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ event.name }}
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ event.date }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon ripple>
                <v-icon class="red--text text--darken-1 text--lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        </div>
      </v-menu>
      <v-menu v-else disabled>
        <v-btn icon disabled slot="activator">
          <v-icon>track_changes</v-icon>
        </v-btn>
      </v-menu>
      <v-btn
        v-if="selectedVehicle"
        icon
        @click="$emit('open-commands-dialog', { vehicleId: selectedVehicle._id })"
      >
        <v-icon>cloud_upload</v-icon>
      </v-btn>
      <v-btn v-else icon disabled>
        <v-icon>cloud_upload</v-icon>
      </v-btn>
    </v-toolbar>
    <v-toolbar v-if="$vuetify.breakpoint.xsOnly">
      <v-btn
        icon
        @click.stop="$refs.vehicleDialog.open()"
        :loading="loading"
        color="primary"
      >
        <v-icon>directions_car</v-icon>
      </v-btn>
      <v-toolbar-title>
        {{ selectedVehicle ? selectedVehicle.plate : 'Selecciona un vehículo' }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu v-if="selectedVehicle" offset-y top left>
        <v-btn icon slot="activator" @click="unreadEvents = 0">
          <v-badge v-model="unreadEventsBadge.visible" right>
            <span color="primary" slot="badge">{{ unreadEventsBadge.value }}</span>
            <v-icon>track_changes</v-icon>
          </v-badge>
        </v-btn>
        <v-toolbar>
          <v-toolbar-title>Eventos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon>settings</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="events-menu-body">
          <v-list two-line>
            <v-list-tile
              avatar
              v-for="event in events"
              :key="event._id"
              @click="$emit('open-event-dialog', event._id)"
            >
            <v-list-tile-avatar>
              <v-icon v-if="event.highPriority" class="primary white--text">priority_high</v-icon>
              <v-icon v-else class="primary white--text">notifications</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ event.name }}
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ event.date }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon ripple>
                <v-icon class="red--text text--darken-1 text--lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        </div>
      </v-menu>
      <v-menu v-else disabled>
        <v-btn icon disabled slot="activator">
          <v-icon>track_changes</v-icon>
        </v-btn>
      </v-menu>
      <v-btn icon disabled>
        <v-icon>settings</v-icon>
      </v-btn>
    </v-toolbar>
    <vehicle-dialog
      :vehicles="vehicles"
      :selected-vehicle.sync="selectedVehicle"
      ref="vehicleDialog"
    ></vehicle-dialog>
  </div>
</template>

<script>
import VehicleDialog from '@/components/Tracking/VehicleDialog'

export default {
  name: 'actions-toolbar',
  props: {
    focus: String,
    vehicles: {
      type: Array,
      default: function () {
        return []
      }
    },
    events: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      selectedVehicle: null,
      unreadEvents: 0
    }
  },
  computed: {
    unreadEventsBadge: function () {
      return {
        value: this.unreadEvents,
        visible: this.unreadEvents > 0
      }
    }
  },
  watch: {
    events: function (events) {
      if (events.length === 0 || events.length === 1) this.unreadEvents = events.length
      else if (this.unreadEvents >= 99) this.unreadEvents = 99
      else this.unreadEvents++
    },
    selectedVehicle: function (selectedVehicle) {
      if (!selectedVehicle) {
        this.$emit('update:focus', null)
      } else {
        this.$emit('update:focus', this.selectedVehicle._id)
      }
    }
  },
  components: {
    'vehicle-dialog': VehicleDialog
  }
}
</script>

<style lang="sass" scoped>
.events-menu-body
  max-height: 400px
  overflow: auto
</style>



// WEBPACK FOOTER //
// src/components/Tracking/ActionsToolbar.vue